export const GET_ACCESS_TOKEN_ACTION = "GET_ACCESS_TOKEN_ACTION";
export const CLEAN_USER_ACCESS_TOKEN_DATA = "CLEAN_USER_ACCESS_TOKEN_DATA";
